import { FirestoreDataConverter } from "firebase/firestore";

export const converter: FirestoreDataConverter<any> = {
  fromFirestore(snapshot) {
    const data = snapshot.data();

    return {
      ...data,
      id: data.id || snapshot.id,
    };
  },
  toFirestore: (data) => data,
};
